import { createFileRoute } from '@tanstack/react-router'

import { LedgerPage } from '@/pages/admin/ledger/ledger-page'
import { DEFAULT_LEDGER_SEARCH, ledgerSearchSchema } from '@/utils/ledger-search-params'

export const Route = createFileRoute('/_private/admin/ledger')({
  component: LedgerPage,
  // Filters / sort / page live in the URL. `.catch()` reverts a malformed link
  // to the default view instead of hard-failing inside the router.
  validateSearch: (search) => ledgerSearchSchema.catch(DEFAULT_LEDGER_SEARCH).parse(search),
})
